module.exports = __webpack_public_path__ + "static/media/wechat.14208b3f.svg";